import { render } from "./DeliveryAddressManagement.vue?vue&type=template&id=008d381e"
import script from "./DeliveryAddressManagement.vue?vue&type=script&lang=js"
export * from "./DeliveryAddressManagement.vue?vue&type=script&lang=js"

import "./DeliveryAddressManagement.vue?vue&type=style&index=0&id=008d381e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/app/components/DeliveryAddressManagement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "008d381e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('008d381e', __exports__)) {
    api.reload('008d381e', __exports__)
  }
  
  module.hot.accept("./DeliveryAddressManagement.vue?vue&type=template&id=008d381e", () => {
    api.rerender('008d381e', render)
  })

}


export default __exports__